(() => {
  'use strict';
  if (window.CgauGearEntrance) return;
  const script = document.currentScript;
  const pageType = script?.dataset.pageType || '';
  const path = '/pages/eufy-compatibility';
  const key = 'cgau:gear-entrance:v1';
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const blocked = value => /(?:^|\/)products(?:\/|$)|^\/(?:cart|checkout|account|search|policies|password|challenge)(?:\/|$)|^\/pages\/(?:contact|[^/]*(?:warranty|consumer-rights|returns-form|claim-form)[^/]*)(?:\/|$)/.test(value);
  let scene = null;
  let timer;
  let frame;
  let controller;
  let previousInert = new Map();

  const finish = (reason = 'complete') => {
    cancelAnimationFrame(frame);
    clearTimeout(timer);
    controller?.abort();
    window.CgauGearEntranceBoot?.release(reason !== 'complete');
    if (!scene) return;
    const restoreFocus = scene.contains(document.activeElement) && !document.hidden && reason !== 'pagehide';
    scene.remove();
    scene = null;
    previousInert.forEach((value, node) => { if (node.isConnected) node.inert = value; });
    previousInert.clear();
    performance.mark(`cgau-gear:end:${reason}`);
    if (restoreFocus) {
      const heading = document.querySelector('main h1, #MainContent h1, h1');
      if (heading) {
        const hadTabindex = heading.hasAttribute('tabindex');
        if (!hadTabindex) heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
        if (!hadTabindex) heading.addEventListener('blur', () => heading.removeAttribute('tabindex'), { once: true });
      }
    }
  };

  const start = () => {
    const boot = window.CgauGearEntranceBoot;
    const template = document.getElementById('cgau-gear-entrance-template');
    if (!boot || boot.cancelled || motion.matches || document.hidden || !template || scene) { boot?.release(true); return; }
    scene = template.content.firstElementChild.cloneNode(true);
    scene.setAttribute('role', 'dialog');
    scene.setAttribute('aria-modal', 'true');
    scene.setAttribute('aria-label', 'Opening the compatibility checker');
    document.body.append(scene);
    if (getComputedStyle(scene).position !== 'fixed') { finish('missing-style'); return; }
    for (const child of document.body.children) {
      if (child === scene || child.tagName === 'SCRIPT' || child.tagName === 'TEMPLATE' || child.tagName === 'STYLE') continue;
      previousInert.set(child, child.inert);
      child.inert = true;
    }
    controller = new AbortController();
    const options = { signal: controller.signal };
    scene.querySelector('[data-gear-skip]')?.addEventListener('click', () => finish('skip'), options);
    window.addEventListener('keydown', event => { if (event.key === 'Escape' || event.key === 'Tab') finish('keyboard'); }, options);
    window.addEventListener('wheel', () => finish('scroll'), { ...options, passive: true });
    window.addEventListener('pagehide', () => finish('pagehide'), options);
    window.addEventListener('hashchange', () => finish('hash'), options);
    document.addEventListener('visibilitychange', () => { if (document.hidden) finish('hidden'); }, options);
    motion.addEventListener('change', event => { if (event.matches) finish('reduced-motion'); }, options);
    boot.release(false);
    scene.querySelector('[data-gear-skip]')?.focus({ preventScroll: true });
    performance.mark('cgau-gear:mounted');
    timer = setTimeout(() => finish('frame-timeout'), 3000);
    frame = requestAnimationFrame(() => {
      if (!scene) return;
      scene.setAttribute('data-running', '');
      performance.mark('cgau-gear:start');
      clearTimeout(timer);
      timer = setTimeout(() => finish('complete'), 2800);
    });
  };

  window.CgauGearEntrance = { finish };
  start();
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    try { sessionStorage.removeItem(key); } catch (_) {}
    finish('back-forward');
  });
  window.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || motion.matches || document.hidden) return;
    if (/^(?:product|cart|search|policy|404|password)$/.test(pageType) || blocked(location.pathname)) return;
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || link.hasAttribute('download') || link.relList.contains('external') || (link.target && link.target.toLowerCase() !== '_self')) return;
    let target;
    try { target = new URL(link.href); } catch (_) { return; }
    if (target.origin !== location.origin || target.pathname.replace(/\/$/, '') !== path || target.hash || location.pathname.replace(/\/$/, '') === path) return;
    try { sessionStorage.setItem(key, JSON.stringify({ v: 1, at: Date.now(), from: location.href, to: target.href })); } catch (_) {}
  });
})();
